import React from "react";
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  Button,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionPanel,
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";

interface PromptsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedRule: { clauseTopic: string } | null;
  selectedPromptRule: Record<string, any> | null;
  dialogTitleClassName?: string;
  promptContentClassName?: string;
}

export const PromptsDialog: React.FC<PromptsDialogProps> = ({
  open,
  onOpenChange,
  selectedRule,
  selectedPromptRule,
  dialogTitleClassName,
  promptContentClassName,
}) => {
  if (!selectedRule || !selectedPromptRule) return null;
  return (
    <Dialog open={open} onOpenChange={(_event, data) => onOpenChange(data.open)}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle className={dialogTitleClassName}>
            <span>Prompts used for {selectedRule.clauseTopic}</span>
            <Button icon={<Dismiss24Regular />} onClick={() => onOpenChange(false)} aria-label="Close" />
          </DialogTitle>
          <DialogContent>
            <div className={promptContentClassName}>
              <Accordion multiple collapsible>
                {Object.entries(selectedPromptRule).map(([key, promptUsed], i) => {
                  if (key === "id" || key === "clauseTopic") return null;
                  return (
                    <AccordionItem key={`prompt-used-${i}`} value={key}>
                      <AccordionHeader>{key}</AccordionHeader>
                      <AccordionPanel>
                        <Accordion multiple collapsible>
                          <AccordionItem value="system">
                            <AccordionHeader>System Prompt</AccordionHeader>
                            <AccordionPanel>
                              <pre className={promptContentClassName}>
                                {Array.isArray(promptUsed.system) ? promptUsed.system.join("\n") : promptUsed.system}
                              </pre>
                            </AccordionPanel>
                          </AccordionItem>
                          <AccordionItem value="user">
                            <AccordionHeader>User Prompt</AccordionHeader>
                            <AccordionPanel>
                              <pre className={promptContentClassName}>
                                {Array.isArray(promptUsed.user) ? promptUsed.user.join("\n") : promptUsed.user}
                              </pre>
                            </AccordionPanel>
                          </AccordionItem>
                        </Accordion>
                      </AccordionPanel>
                    </AccordionItem>
                  );
                })}
              </Accordion>
            </div>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
